import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { pbPortal } from '../lib/pb';
import { useData } from '../data/DataProvider';
import Skeleton from '../shared/components/Skeleton';
import PortalShell from '../shared/layout/PortalShell';

// Auth gate for the client portal (OTP magic-link era,
// docs/auth_magic_link_spec.md).
//
// Two route shapes land here:
//   /portal/:tenantSlug           — session route: already-signed-in
//                                   clients go straight to the portal,
//                                   everyone else bounces to /portal/login.
//   /portal/:tenantSlug/:token    — LEGACY token bookmarks (pre-OTP):
//                                   the portal_token flow is gone, so
//                                   these redirect to /portal/verify where
//                                   the recovery screen offers a fresh OTP
//                                   link by email.
//
// The OTP exchange itself happens on /portal/verify (outside this gate);
// sessions land in the DEDICATED portal store (pbPortal) so they can
// never clobber an admin session (E1/E5).
export default function PortalAuthGate() {
  const { tenantSlug, clientToken } = useParams();
  const { ready } = useData();
  const navigate = useNavigate();

  const portalSession = pbPortal.authStore.record;
  const hasPortalSession = Boolean(
    pbPortal.authStore.isValid && portalSession && portalSession.role === 'client'
  );

  useEffect(() => {
    // Legacy token route — the token exchange endpoint is gone.
    if (clientToken) {
      navigate('/portal/verify', { replace: true });
      return;
    }

    // Session route without a valid client session → login screen.
    if (!hasPortalSession) {
      navigate(`/portal/login${tenantSlug ? `/${tenantSlug}` : ''}`, { replace: true });
    }
  }, [clientToken, tenantSlug, hasPortalSession, navigate]);

  // Still resolving / bouncing — render a skeleton (never stale content).
  if (clientToken || !hasPortalSession) {
    return <div className="standalone-page"><Skeleton rows={5} /></div>;
  }

  if (!ready) {
    return <div className="standalone-page"><Skeleton rows={6} /></div>;
  }

  return <PortalShell />;
}
